import { StripeError } from '@stripe/stripe-js'

export class APIError extends Error {
  statusCode: number

  errorManagerMessage: string | null | undefined

  errorManagerFields: Record<string, string>

  constructor(
    message: string,
    statusCode: number,
    errorManagerMessage: string | undefined | null,
    errorManagerFields: Record<string, string> = {},
  ) {
    super(message)
    this.statusCode = statusCode
    this.errorManagerMessage = errorManagerMessage
    this.errorManagerFields = errorManagerFields
  }

  static fromStripeError(stripeError: StripeError) {
    return new APIError(stripeError.code as string, 0, stripeError.message)
  }
}
